export const WEEKDAY_KEYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

/**
 * Project a rotating schedule onto a weeks x 7 grid.
 * Rest weekdays are null; training days walk `rotation` continuously across the whole grid.
 * @returns Array<Array<{ weekday: string, label: string|null }>>
 */
export function computeRotatingPreview(restWeekdays, rotation, weeks = 2) {
  const rest = new Set(restWeekdays || []);
  const rot = rotation || [];
  let pointer = 0;
  const grid = [];
  for (let w = 0; w < weeks; w++) {
    const row = [];
    for (const weekday of WEEKDAY_KEYS) {
      if (rest.has(weekday) || rot.length === 0) {
        row.push({ weekday, label: null });
      } else {
        row.push({ weekday, label: rot[pointer % rot.length].name });
        pointer += 1;
      }
    }
    grid.push(row);
  }
  return grid;
}
